function Footer() {
  return (
    <div className="App">
      <footer className="text-center">
        <p>
          &copy; {new Date().getFullYear()} <b>River Pools</b>
        </p>
      </footer>
    </div>
  );
}

export default Footer;
